import { Controller } from "@hotwired/stimulus"

// Lets images be dropped anywhere on the element and routes them into the file input.
export default class extends Controller {
  static targets = ["input", "overlay", "current", "preview"]

  connect() {
    this.dragDepth = 0
  }

  disconnect() {
    this.revokePreviewUrl()
  }

  enter(event) {
    if (!this.draggingFiles(event)) return

    event.preventDefault()
    this.dragDepth++
    this.overlayTarget.classList.remove("hidden")
  }

  over(event) {
    if (!this.draggingFiles(event)) return

    event.preventDefault()
    event.dataTransfer.dropEffect = "copy"
  }

  leave(event) {
    if (!this.draggingFiles(event)) return

    this.dragDepth = Math.max(this.dragDepth - 1, 0)
    if (this.dragDepth === 0) this.hideOverlay()
  }

  drop(event) {
    if (!this.draggingFiles(event)) return

    event.preventDefault()
    this.dragDepth = 0
    this.hideOverlay()

    const images = Array.from(event.dataTransfer.files).filter((file) => file.type.startsWith("image/"))
    if (images.length === 0) return

    const transfer = new DataTransfer()
    const files = this.inputTarget.multiple ? images : images.slice(0, 1)
    files.forEach((file) => transfer.items.add(file))
    this.inputTarget.files = transfer.files
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  browse() {
    this.inputTarget.click()
  }

  showPreview() {
    const file = this.inputTarget.files[0]
    this.revokePreviewUrl()

    if (!file) {
      this.previewTarget.classList.add("hidden")
      this.currentTargets.forEach((element) => element.classList.remove("hidden"))
      return
    }

    this.previewUrl = URL.createObjectURL(file)
    this.previewTarget.src = this.previewUrl
    this.previewTarget.classList.remove("hidden")
    this.currentTargets.forEach((element) => element.classList.add("hidden"))
  }

  draggingFiles(event) {
    return event.dataTransfer?.types.includes("Files")
  }

  hideOverlay() {
    this.overlayTarget.classList.add("hidden")
  }

  revokePreviewUrl() {
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl)
    this.previewUrl = null
  }
}
